import React from "react";
import Button from "../../button/button";
import DropdownButton, {
  IDropdownMenuOption,
} from "../../dropdown-button/dropdown-button";

import './report-buttons.scss'
import { ButtonProps, SxProps } from "@mui/material";

export interface IActionButtons {
  title?: string;
  icon?: React.ReactNode;
  btnStyle?: "WhiteBtn";
  variant?: "text" | "outlined" | "contained";
  action?: () => void;
  class?: string;
}

export interface IReportButtons extends ButtonProps { 
  className?: string;
  buttons?: IActionButtons[];
  dropdownMenuButtonData?: {
    icon?: React.ReactNode;
    children?: React.ReactNode;
    options: IDropdownMenuOption[];
    sx?: SxProps;
  } | null;
  toggleCallback?: (e?: boolean) => void;
  zIndex?: number;
  iconPosition: 'start' | 'end';
}

const ReportButtons = ({ buttons, dropdownMenuButtonData = null, toggleCallback, className, zIndex = 999, iconPosition = 'start', ...rest }: IReportButtons) => {
  return (
    <div className={className}>
      {buttons?.map((ele) => (
        <Button
          className={
            ele.class
              ? ele.class
              : `wrapper--${ele?.btnStyle}`
          }
          key={ele.title}
          variant={ele.variant ? ele.variant : "contained"}
          startIcon={ele.icon ? ele.icon : ""}
          onClick={ele.action}
        >
          {ele.title ?? ""}
        </Button>
      ))}
      {dropdownMenuButtonData && (
        <div style={{ zIndex }}>
          <DropdownButton
            options={dropdownMenuButtonData.options || []}
            {...(iconPosition === 'start' ? { startIcon: dropdownMenuButtonData.icon } : { endIcon: dropdownMenuButtonData.icon })}
            isMenuThirdItemDisabled={true}
            isOnlyDropDownButton={true}
            variant={"text"}
            buttonGroupProps={{
              variant: "text",
            }}
            onlyDropDownButtonProps={{
              style: {
                backgroundColor: "white !important",
                color: "black !important",
                ...dropdownMenuButtonData.sx
              },
            }}
            toggleCallback={toggleCallback}
            {...rest}
          >
            {dropdownMenuButtonData.children}
          </DropdownButton>
        </div>
      )}
    </div>
  );
};
export { ReportButtons };
export default ReportButtons;
